// @flow
import React, { PureComponent } from 'react';
import { Redirect } from 'react-router-dom';

import Loading from 'components/fragments/Loading';
import RencontreGeneralSoon from 'containers/rencontre/general/RencontreGeneralSoonContainer';
import RencontreGeneralResult from 'containers/rencontre/general/RencontreGeneralResultContainer';
import RencontreGeneralLive from 'containers/rencontre/general/RencontreGeneralLiveContainer';

import type { RencontreType, RencontreLiveType } from 'types/Rencontre';
import type { RouterProps } from 'types/Router';

export type StateProps = {
  rencontre: ?RencontreType,
  rencontresLive: {
    [key: string]: RencontreLiveType,
  },
};

type Props = StateProps & RouterProps;


class RencontreGeneral extends PureComponent<Props> {
  _renderContent = (etat: string, id: string) => {
    const { match: { url }, rencontresLive } = this.props;
    const urlbase = url.replace('/general', '');
    const statsUrl = `${urlbase}${urlbase[urlbase.length - 1] === '/' ? '' : '/'}statistiques-classement`;
    const rencontresLiveKeys = Object.keys(rencontresLive);
    if (rencontresLiveKeys.includes(id) && etat === 'Planifiée') {
      window.location.reload(true);
    }

    switch (etat) {
      case 'Planifiée':
        return <RencontreGeneralSoon />;
      case 'Terminée':
      case 'Score validé':
      case 'Présaisie':
      case 'En instance':
        return <RencontreGeneralResult />;
      case 'En direct':
        return <RencontreGeneralLive />;
      default:
        return <Redirect to={statsUrl}/>;
    }
  };

  render() {
    const { rencontre } = this.props;

    if (!rencontre) {
      return <Loading />;
    }

    return (
      <section>
        <div className="page">
          {this._renderContent(rencontre.etat, rencontre.id)}
        </div>
      </section>
    );
  }
}

export default RencontreGeneral;
